import type { Dispatch } from 'redux';
import type { FormState } from 'informed';
import QuoteWizardState from '../../store/QuoteWizardState';
import { QuoteWizardForm } from '../QuoteWizard/classes';
import type { QuoteWizardAnsweredForm } from '../QuoteWizard/classes';
import { formStateToAnswerInstances } from '../QuoteWizard/QuoteForms/utility';
import { amendAnswersListWithDefaultAnswers } from '../util/Quote/hybridAnswers';
import type { QuoteStatus } from '../../Typescript/backend/types/QuoteStatus';
import type { UnifiedAnswerInstance } from '../../Typescript/classes';

const toCompletedFormWithAnswers = (
  form: QuoteWizardForm,
  answers: Array<UnifiedAnswerInstance>,
) => {
  const completedForm = form.toDefaultUnifiedCompletedForm();
  completedForm.answers = amendAnswersListWithDefaultAnswers(
    answers,
    form.questionInstances,
  );
  return completedForm;
};

export const submitAxisInquiryQuote = (
  dispatch: Dispatch,
  form: QuoteWizardForm,
  formState: FormState,
  currentQuoteUUID: string | null = null,
  status: QuoteStatus = 'COMPLETE',
  formAnswers: Record<string, QuoteWizardAnsweredForm> = {},
) => {
  const answers = formStateToAnswerInstances(
    formState.values,
    form.questionInstances,
  );
  dispatch(QuoteWizardState.actions.submitAnswersForForm({ form, answers }));

  const currentFormWithAnswers = toCompletedFormWithAnswers(
    form,
    answers.map((answer) => answer.toUnifiedAnswerInstance()),
  );

  const otherFormsWithAnswers = Object.values(formAnswers)
    .filter((answeredForm) => answeredForm.form.id !== form.id)
    .map((answeredForm) =>
      toCompletedFormWithAnswers(
        answeredForm.form,
        answeredForm.toUnifiedCompletedForm().answers,
      ),
    );

  dispatch(
    QuoteWizardState.actions.confirmAnswersForForms({
      formsWithAnswers: [...otherFormsWithAnswers, currentFormWithAnswers],
      status,
      currentQuoteUUID,
      selectedPolicies: [],
      signature: null,
      renewalInProgress: false,
      storeExistingQuoteUuidOnComplete: false,
    }),
  );
};
